// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__SXTn0","buttons":"Header_buttons__qrm31","locPanel":"Header_locPanel__ODIXo","isCurrent":"Header_isCurrent__wclD2"};